module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Bold.01a151b8.otf";